import { Component, HostListener } from '@angular/core';
import { FormBuilder, Validators, FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersService } from '../../services/users.service';
import { ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-reset-my-password',
  standalone: false,
  templateUrl: './reset-my-password.component.html',
  styleUrl: './reset-my-password.component.scss'
})
export class ResetMyPasswordComponent {
  form: FormGroup;
  isSaving = false;
  usernameFromParam: string = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly usersService: UsersService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      username: ['', Validators.required],
      old_password: ['', Validators.required],
      new_password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_password: ['', Validators.required]
    }, { validators: this.passwordsMatch });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
       this.usernameFromParam = params['username'] || '';
      if (this.usernameFromParam) {
        this.form.get('username')?.setValue(this.usernameFromParam);
        this.form.get('username')?.disable();
      }
    });
  }

  passwordsMatch(group: AbstractControl): ValidationErrors | null {
    const newPassword = group.get('new_password')?.value;
    const confirmPassword = group.get('confirm_password')?.value;
    const confirmControl = group.get('confirm_password');

    if (!confirmControl) {
      return null;
    }

    if (!confirmPassword) {
      if (confirmControl.hasError('passwordMismatch')) {
        confirmControl.setErrors(null);
      }
      return null;
    }

    if (newPassword !== confirmPassword) {
      confirmControl.setErrors({ passwordMismatch: true });
    } else if (confirmControl.hasError('passwordMismatch')) {
      confirmControl.setErrors(null);
    }

    return null;
  }

  onSubmit() {
    if (this.form.invalid) return;

    const username = this.usernameFromParam || this.form.get('username')?.value;
    const { old_password, new_password } = this.form.value;

    this.isSaving = true;

    this.usersService.resetMyPassword(username, old_password, new_password).subscribe({
      next: (res: any) => {
        if (res?.data?.error === "The old password is not correct.") {
          this.form.get('old_password')?.setErrors({ invalidOldPassword: true });
          this.isSaving = false;
          return;
        }
        this.snackBar.open('Password reset successfully', 'Close', { duration: 3000 });
        this.form.reset();

        if (this.usernameFromParam) {
          this.router.navigate(['dashboard/users/profile']);
        } else {
          this.router.navigate(['/login']);
        }
      },
      error: () => {
        this.snackBar.open('Failed to reset password', 'Close', { duration: 3000 });
        this.isSaving = false;
      }
    });
  }
   @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    this.onSubmit();
  }
}